'use client';
import { useEffect, useRef } from 'react';
import { beginKagemanePerformance, reportKagemanePerformance } from './kagemane-performance';

export function useKagemanePerformance(loading: boolean, error: boolean) {
  const ready = useRef(false);
  useEffect(() => {
    try {
      const direct = beginKagemanePerformance();
      const observer = direct && typeof PerformanceObserver !== 'undefined' ? new PerformanceObserver((entries) => {
        const fcp = entries.getEntries().find(entry => entry.name === 'first-contentful-paint');
        if (fcp) void reportKagemanePerformance('fcp', fcp.startTime);
      }) : null;
      observer?.observe({ type: 'paint', buffered: true });
      const hide = () => { if (!ready.current) void reportKagemanePerformance('hidden_before_catalog'); };
      window.addEventListener('pagehide', hide);
      return () => { observer?.disconnect(); window.removeEventListener('pagehide', hide); };
    } catch { /* Older WebViews can lack performance observation. */ }
  }, []);
  useEffect(() => {
    if (loading) return;
    ready.current = !error;
    void reportKagemanePerformance(error ? 'catalog_error' : 'catalog_ready');
  }, [loading, error]);
}
